import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-291ce846"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "xag-container" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "content" }
const _hoisted_4 = { class: "name" }
const _hoisted_5 = { class: "count" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_header = _resolveComponent("app-header")!
  const _component_van_empty = _resolveComponent("van-empty")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_app_header, { title: "可用备用产品" }),
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, i) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "cell-item xag-flex",
          key: i
        }, [
          _createElementVNode("img", {
            class: "cell-img",
            src: item.img || '/images/avatar_img_48_p40_normal.svg',
            alt: ""
          }, null, 8, _hoisted_2),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(item.product_name), 1),
            _createElementVNode("div", _hoisted_5, "剩余 " + _toDisplayString(item.count) + " 个", 1)
          ])
        ]))
      }), 128)),
      (!_ctx.items.length && !_ctx.isLoading)
        ? (_openBlock(), _createBlock(_component_van_empty, {
            key: 0,
            description: "无可用备用产品"
          }))
        : _createCommentVNode("", true)
    ])
  ], 64))
}